const DEFAULT_SITE_URL = "https://www.team-laurien-alex.de/"
const PROTOCOL_PREFIX_RE = /^[a-zA-Z][a-zA-Z\d+.-]*:/
const FILE_PATH_RE = /\/[^/?#]+\.[^/?#]+$/

function ensureBaseUrl(siteUrl = DEFAULT_SITE_URL) {
  return siteUrl.endsWith("/") ? siteUrl : `${siteUrl}/`
}

export function normalizePagePath(pathname = "/") {
  const rawPath = pathname || "/"
  let normalizedPath = rawPath.startsWith("/") ? rawPath : `/${rawPath}`

  normalizedPath = normalizedPath.replace(/\/{2,}/g, "/")

  if (
    normalizedPath !== "/" &&
    !normalizedPath.endsWith("/") &&
    !FILE_PATH_RE.test(normalizedPath)
  ) {
    normalizedPath = `${normalizedPath}/`
  }

  return normalizedPath
}

export function normalizeInternalHref(href, siteUrl = DEFAULT_SITE_URL) {
  if (!href || href.startsWith("#") || href.startsWith("//")) {
    return href
  }

  if (
    href.startsWith("mailto:") ||
    href.startsWith("tel:") ||
    href.startsWith("sms:") ||
    href.startsWith("javascript:")
  ) {
    return href
  }

  const baseUrl = ensureBaseUrl(siteUrl)

  if (PROTOCOL_PREFIX_RE.test(href)) {
    const parsedUrl = new URL(href)

    if (parsedUrl.origin !== new URL(baseUrl).origin) {
      return href
    }

    return `${normalizePagePath(parsedUrl.pathname)}${parsedUrl.search}${parsedUrl.hash}`
  }

  const parsedUrl = new URL(href, baseUrl)

  return `${normalizePagePath(parsedUrl.pathname)}${parsedUrl.search}${parsedUrl.hash}`
}

export function buildCanonicalUrl(pathname = "/", siteUrl = DEFAULT_SITE_URL) {
  const baseUrl = ensureBaseUrl(siteUrl)
  const parsedUrl = new URL(pathname || "/", baseUrl)

  return new URL(normalizePagePath(parsedUrl.pathname), baseUrl).toString()
}

// Keep attribution on internal navigation without overwriting a link's own query.
export function preserveQueryString(href, search = "") {
  if (!href || !search || !/^\/(?!\/)/.test(href)) return href

  const target = new URL(href, DEFAULT_SITE_URL)
  const inherited = new URLSearchParams(search)
  const explicitKeys = new Set(target.searchParams.keys())

  for (const [key, value] of inherited) {
    if (!explicitKeys.has(key)) target.searchParams.append(key, value)
  }

  return `${target.pathname}${target.search}${target.hash}`
}
